import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import { LinkContainer } from "react-router-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Images from "./Images";
import PageList from "./pages/PageList";
import EditPage from "./pages/EditPage";
import CreatePage from "./pages/CreatePage";
import PostList from "./posts/PostList";
import EditPost from "./posts/EditPost";
import CreatePost from "./posts/CreatePost";
import NavSlotList from "./nav/NavSlotList";
import CreateNavSlot from "./nav/CreateNavSlot";
import EditNavSlot from "./nav/EditNavSlot";
import Files from "./Files";
import EditProduct from "./products/EditProduct";
import CreateProduct from "./products/CreateProduct";
import ProductList from "./products/ProductList";
import GuardedRoute from "../common/GuardedRoute";
import { hasAdminRole, hasECAdminRole } from "../utils";
import { AppContext } from "../store";
import RDList from "./rds/RDList";
import EditRD from "./rds/EditRD";
import CreateRD from "./rds/CreateRD";

const CMS = () => {
  const { state } = useContext(AppContext);
  const roles = state?.orgInfo?.roles;
  const isAdmin = hasAdminRole(roles);
  const isECAdmin = hasECAdminRole(roles);
  return React.createElement(
    "div",
    null,
    <div>
      <h1>Feather Content Admin</h1>
      <Navbar className="navbar-dark bg-slate rounded ps-3 pe-3">
        <Nav>
          {isAdmin && (
            <>
              <LinkContainer to={`/admin/`}>
                <Nav.Link>Pages</Nav.Link>
              </LinkContainer>
              <LinkContainer to={`/admin/news`}>
                <Nav.Link>News</Nav.Link>
              </LinkContainer>
              <LinkContainer to={`/admin/images`}>
                <Nav.Link>Images</Nav.Link>
              </LinkContainer>
              <LinkContainer to={`/admin/files`}>
                <Nav.Link>Files</Nav.Link>
              </LinkContainer>
              <LinkContainer to={`/admin/products`}>
                <Nav.Link>Products</Nav.Link>
              </LinkContainer>
              <LinkContainer to={`/admin/navigation`}>
                <Nav.Link>Menus</Nav.Link>
              </LinkContainer>
            </>
          )}
          {isECAdmin && (
            <>
              <LinkContainer to={`/admin/rds`}>
                <Nav.Link>RDs</Nav.Link>
              </LinkContainer>
            </>
          )}
        </Nav>
      </Navbar>
      <Routes>
        <Route
          index
          element={
            <GuardedRoute auth={isAdmin || isECAdmin}>
              <PageList />
            </GuardedRoute>
          }
        />
        <Route
          path={`edit-rd/:id`}
          element={
            <GuardedRoute auth={isECAdmin}>
              <EditRD />
            </GuardedRoute>
          }
        />
        <Route
          path={`rds`}
          element={
            <GuardedRoute auth={isECAdmin}>
              <RDList />
            </GuardedRoute>
          }
        />
        <Route
          path={`create-rd`}
          element={
            <GuardedRoute auth={isECAdmin}>
              <CreateRD />
            </GuardedRoute>
          }
        />
        <Route
          path={`news`}
          element={
            <GuardedRoute auth={isAdmin}>
              <PostList />
            </GuardedRoute>
          }
        />
        <Route
          path={`images`}
          element={
            <GuardedRoute auth={isAdmin}>
              <Images />
            </GuardedRoute>
          }
        />
        <Route
          path={`files`}
          element={
            <GuardedRoute auth={isAdmin}>
              <Files />
            </GuardedRoute>
          }
        />
        <Route
          path={`navigation/`}
          element={
            <GuardedRoute auth={isAdmin}>
              <NavSlotList />
            </GuardedRoute>
          }
        />
        <Route
          path={`edit-page/:id`}
          element={
            <GuardedRoute auth={isAdmin}>
              <EditPage />
            </GuardedRoute>
          }
        />
        <Route
          path={`create-page/`}
          element={
            <GuardedRoute auth={isAdmin}>
              <CreatePage />
            </GuardedRoute>
          }
        />
        <Route
          path={`edit-post/:id`}
          element={
            <GuardedRoute auth={isAdmin}>
              <EditPost />
            </GuardedRoute>
          }
        />
        <Route
          path={`create-post/`}
          element={
            <GuardedRoute auth={isAdmin}>
              <CreatePost />
            </GuardedRoute>
          }
        />
        <Route
          path={`edit-product/:id`}
          element={
            <GuardedRoute auth={isAdmin}>
              <EditProduct />
            </GuardedRoute>
          }
        />
        <Route
          path={`create-product/`}
          element={
            <GuardedRoute auth={isAdmin}>
              <CreateProduct />
            </GuardedRoute>
          }
        />
        <Route
          path={`products/`}
          element={
            <GuardedRoute auth={isAdmin}>
              <ProductList />
            </GuardedRoute>
          }
        />
        <Route
          path={`edit-nav/:slug`}
          element={
            <GuardedRoute auth={isAdmin}>
              <EditNavSlot />
            </GuardedRoute>
          }
        />
        <Route
          path={`create-nav/`}
          element={
            <GuardedRoute auth={isAdmin}>
              <CreateNavSlot />
            </GuardedRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default CMS;
